export const isPlaybackRejection = (e?: {
    name?: string;
    type?: string;
}): boolean =>
    !e?.type && (e?.name === "NotAllowedError" || e?.name === "AbortError");
